<div class="text-white py-16">
  @if(loaded()) {

  @if(notFound()) {
  <app-not-found-page></app-not-found-page>
  } @else {
  @if(page(); as page) {
  <div class="max-w-screen-2xl mx-auto px-8">
    @if(page?.breadcrumbs; as breadcrumbs) {
    @if(breadcrumbs.length > 0) {
    <nav class="flex flex-row gap-2">
      @for(crumb of breadcrumbs; track $index; let last = $last) {
      <a [routerLink]="navRoute(crumb.slug)" class="font-bold text-primary underline">
        {{ crumb.title }}
      </a>
      <span class="select-none text-primary font-bold">&gt;</span>
      }
      <p class="font-bold text-white">{{ page?.title }}</p>
    </nav>
    }}

    <h1 class="text-4xl md:text-6xl font-bold pb-8 leading-tight">{{ page?.title }}</h1>
  </div>

  <div class="flex flex-col gap-8">
    @for(item of page?.content; track $index) {
    <ng-container appContentBlock [data]="item.data" [type]="item.type"></ng-container>
    }

    @if(page.children.length > 0){
    <div class="flex flex-col gap-12 max-w-screen-lg mx-auto p-8 w-full">
      <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
        @for(child of page?.children; track $index) {

        @if(child?.children?.length) {
        <div class="flex flex-col gap-8 col-span-4 items-start">
          <a [routerLink]="['/pages', child.slug]" class="font-bold text-primary text-2xl">{{ child.short_title || child.title }}</a>

          <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            @for(grandchild of child.children; track $index) {
            <ng-container [ngTemplateOutlet]="link"
              [ngTemplateOutletContext]="{ title: grandchild.short_title || grandchild.title, slug: grandchild.slug, image: grandchild.featured_image}"></ng-container>
            }
          </div>
        </div>
        }
        @else {
        <ng-container [ngTemplateOutlet]="link"
          [ngTemplateOutletContext]="{ title: child.short_title || child.title, slug: child.slug, image: child.featured_image}"></ng-container>
        }}
      </div>
    </div>
    }
  </div>
  } <!-- @if(page(); as page) -->
  } <!-- @else (notFound check) -->
  } <!-- @if(loaded()) -->
  @else {
  <div class="flex flex-row items-center justify-center">
    <app-spinner></app-spinner>
  </div>
  }
</div>

<ng-template #link let-title="title" let-slug="slug" let-image="image">
  <a class="flex flex-col gap-4 items-center" [routerLink]="['/pages', slug]">
    <img [src]="image" alt="" class="aspect-square rounded-full object-cover">
    <p class="leading-tight text-center font-bold text-lg">{{ title }}</p>
  </a>
</ng-template>